import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.communityApiUrl, {
  camelizeKeys: true,
});

export async function getInboxViews(config = {}) {
  return http.get('/inbox_views', config);
}

export async function getInboxView(viewId, config = {}) {
  const url = `/inbox_views/${viewId}`;
  return http.get(url, config);
}

export async function createInboxView(payload, config = {}) {
  return http.post('/inbox_views', payload, config);
}

export async function updateInboxView(viewId, payload, config = {}) {
  return http.patch(`/inbox_views/${viewId}`, payload, config);
}

export async function leaveCustomInboxView(viewId, config = {}) {
  return http.delete(`/inbox_views/${viewId}/user_access_grants`, config);
}

export async function deleteCustomInboxView(viewId, config = {}) {
  const url = `/inbox_views/${viewId}`;
  return http.delete(url, config);
}
